import styled from "styled-components";

export const StyledTranslate = styled.div`
  /*  margin: ${({ margin }) => margin}*/
`
